import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const HEADLINE = 'The mistake was in the chart. Nobody looked.';

const Home = () => {
  useEffect(() => {
    document.title = 'Afterimage Labs';
  }, []);

  return (
    <main>
      <section className="ai-hero">
        <div className="ai-wrap">
          <h1>
            <span className="ghost" aria-hidden="true">{HEADLINE}</span>
            <span className="real">{HEADLINE}</span>
          </h1>
          <p className="lede">
            When a diagnosis is missed or delayed, the warning signs are usually
            already in the medical record: a scan nobody followed up on, a lab
            value that sat for weeks. We get those records, read them, and help
            patients find out what happened and who is responsible.
          </p>
          <div className="ai-actions">
            <a className="ai-btn" href="mailto:hello@afterimage.health?subject=A%20case%20to%20review">
              Ask us to review a case
            </a>
            <Link className="ai-textlink" to="/mission">Why we started</Link>
          </div>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>How often this happens</h2>
          <ul className="ai-figures">
            <li>
              <b>1 in 5</b>
              patients goes through a diagnostic error at some point in their care.
              Most are minor. Some aren't.
            </li>
            <li>
              <b>1 million+</b>
              people are permanently disabled or killed by one every year. Somewhere
              between 5,000 and 10,000 of those cases ever get investigated.
            </li>
            <li>
              <b>95%</b>
              of patients who call a malpractice attorney hear "sorry, we can't
              help" on the first call. Most never call at all.
            </li>
          </ul>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>What we do about it</h2>
          <ol className="ai-steps">
            <li>
              <h3>Get the records</h3>
              <p>
                Your records belong to you, and federal law says hospitals have to
                hand them over. They rarely make it easy. We send the requests, follow up when they stall, and
                keep the deadline in front of them until the files arrive.
              </p>
            </li>
            <li>
              <h3>Read every page</h3>
              <p>
                Our software turns thousands of pages into a timeline of what was
                seen, when, and by whom. It flags the places where a diagnosis
                should have come sooner. A person checks every flag.
              </p>
            </li>
            <li>
              <h3>Send it somewhere useful</h3>
              <p>
                If there's a case, we connect the patient with a malpractice
                attorney who has the review in hand from day one. What we learn
                goes back to providers so the same miss is less likely next time.
              </p>
            </li>
          </ol>
        </div>
      </section>

      <section className="ai-close">
        <div className="ai-wrap">
          <h2>Think a diagnosis was missed?</h2>
          <p>
            Tell us what happened, even if you're not sure it counts. We'll get
            the records and tell you plainly what they show.
          </p>
          <div className="ai-actions">
            <a className="ai-btn" href="mailto:hello@afterimage.health?subject=A%20case%20to%20review">
              Email hello@afterimage.health
            </a>
            <Link className="ai-textlink" to="/careers">Work with us instead</Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
